// extracted by mini-css-extract-plugin
module.exports = {"card":"AddTransactionForm_card__1skNS","outer":"AddTransactionForm_outer__3w0TG","inner":"AddTransactionForm_inner__3Xq8p"};